<template>
  <div class="w-full">
    <div class="sm:flex hidden w-full pr-6">
      <div class="flex w-full" v-for="(state, index) in states" :key="index">
        <div
          class="vx-card sm:w-9/12 w-full p-1 py-4"
          style="font-size: 12px; text-align: center"
          :class="
            allInformationPackage.state == index - 1
              ? 'bg-success text-white'
              : ''
          "
        >
          <div>
            {{ $t(state[0]) }}
          </div>
          <i class="material-icons" style="font-size: 4rem">
            {{ state[1] }}
          </i>
          <!-- <div v-if="index == 0">
            {{ $t("UserName") }}
            {{
              allInformationPackage.checkOutInfo
                ? allInformationPackage.checkOutInfo
                    .dischargePermissionIssuerUserName
                : "---"
            }}
          </div> -->
          <div>
            {{ $t("StartTime") }}:
            <span v-if="index == 0">
              {{
                allInformationPackage.checkOutInfo
                  ? allInformationPackage.checkOutInfo.startTime.split(" ")[0]
                  : "---"
              }}
            </span>
            <span v-else>
              {{
                allInformationPackage.stateHistories
                  ? allInformationPackage.stateHistories[index - 1]
                    ? allInformationPackage.stateHistories[
                        index - 1
                      ].changeStateDateTime.split(" ")[0]
                    : "---"
                  : "---"
              }}
            </span>
          </div>
          <div>
            {{ $t("StartDate") }}
            <span v-if="index == 0">
              {{
                allInformationPackage.checkOutInfo
                  ? allInformationPackage.checkOutInfo.startTime.split(" ")[1]
                  : "---"
              }}
            </span>
            <span v-else>
              {{
                allInformationPackage.stateHistories
                  ? allInformationPackage.stateHistories[index - 1]
                    ? allInformationPackage.stateHistories[
                        index - 1
                      ].changeStateDateTime.split(" ")[1]
                    : "---"
                  : "---"
              }}
            </span>
          </div>
          <div style="text-align: center" v-if="index == 4">
            <vs-button
              color="success"
              type="gradient"
              size="small"
              icon-pack="feather"
              class="d-inline my-2"
              :disabled="isShowBtnReceipt"
              @click.prevent="onShowReceiptImagePopup()"
            >
              {{ $t("ViewReceipt") }}</vs-button
            >
          </div>
        </div>
        <i
          class="material-icons sm:w-3/12 m-auto pl-3"
          style="font-size: 3.3rem"
          v-if="index <= 4"
        >
          <span class="material-symbols-rounded"> keyboard_backspace </span>
        </i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    allInformationPackage: {},
    isShowBtnReceipt: "",
  },
  data() {
    return {
      states: [
        ["preparing", "hourglass_empty"],
        ["WaitingForAssignOperator", "inventory"],
        ["WaitingForDeliveryToOperator", "person_add"],
        ["WaitingForDeliveryToCustomer", "airport_shuttle"],
        ["WaitingForConfirm", "check"],
        ["Confirmed", "done_all"],
      ],
    };
  },
  methods: {
    onShowReceiptImagePopup() {
      this.isShowReceiptImagePopup = true;
      this.PackagereceiptImageInfo = this.allInformationPackage.receiptImage;
      this.$emit("ShowAttachFilePopup", this.PackagereceiptImageInfo);
    },
  },
};
</script>

<style></style>
